import React from "react";
import "./Advantages_Video_Wala_Bus_Stand.css";
import Advantages_Video_Wala_Bus_Stand_Card from "./Advantages_Video_Wala_Bus_Stand_Card/Advantages_Video_Wala_Bus_Stand_Card";

function Advantages_Video_Wala_Bus_Stand() {
  const advantagesData = [
    {
      imgSrc:
        "/Assets/Images/Service/Services/Advantages_Video_Wala_Bus_Stand_Card_img/img_1.png",
      imgName: "Unmatched",
      imgName2: "Audience Reach",
      imgNumber: "1",
      overlayDiscription:
        "With 366 bus stands spread across Maharashtra, Videowala Bus Stand ensures your advertisements reach 75 lakhs to 1.5 crore unique travellers daily. This diverse audience includes people from various demographics - students, professionals, families, and rural travellers - giving your brand exposure to a wide spectrum of potential customers.",
    },
    {
      imgSrc:
        "/Assets/Images/Service/Services/Advantages_Video_Wala_Bus_Stand_Card_img/img_2.png",
      imgName: "Seamless",
      imgName2: "Rural Penetration",
      imgNumber: "2",
      overlayDiscription:
        "One of the standout features of this platform is its ability to connect businesses with rural audiences. Maharashtra's remote regions often lack access to traditional advertising channels like billboards & television. Videowala Bus Stand bridges this gap, bringing your brand to untapped markets and enabling you to expand your customer base in these areas.",
    },
    {
      imgSrc:
        "/Assets/Images/Service/Services/Advantages_Video_Wala_Bus_Stand_Card_img/img_3.png",
      imgName: "High-Quality",
      imgName2: "Display Technology",
      imgNumber: "3",
      overlayDiscription:
        "Ads are displayed on HD screens of 42 inches and 32 inches, delivering crystal-clear visuals & unmatched sound quality. This ensuresyour content grabs attention and leaves a lasting impression, even in the noisy environment of a bus stand.",
    },
    {
      imgSrc:
        "/Assets/Images/Service/Services/Advantages_Video_Wala_Bus_Stand_Card_img/img_4.png",
      imgName: "Cost-Effective ",
      imgName2: "Advertising",
      imgNumber: "4",
      overlayDiscription:
        "Advertising with Videowala Bus Stand is not only effective but also budget-friendly. With 15-second ad slots offered at highly competitive rates, businesses can achieve extensive visibility without overstretching their budgets. This makes it an ideal platform for both startups & established companies looking to optimize their advertising spend.",
    },
    {
      imgSrc:
        "/Assets/Images/Service/Services/Advantages_Video_Wala_Bus_Stand_Card_img/img_5.png",
      imgName: "Strategic Placement",
      imgName2: "for Maximum Impact",
      imgNumber: "5",
      overlayDiscription:
        "Bus stands are bustling hubs that see a constant influx of travellers, making them ideal locations for advertisements. The strategic placement of HD screens ensures your ads are viewed by a captive audience, increasing the chances of engagement and recall.",
    },
    {
      imgSrc:
        "/Assets/Images/Service/Services/Advantages_Video_Wala_Bus_Stand_Card_img/img_6.png",
      imgName: "Engaging All",
      imgName2: "Categories of Audiences",
      imgNumber: "6",
      overlayDiscription:
        "The audience at bus stands includes people from all walks of life—urban and rural residents, young and old, professionals, and homemakers. This diversity ensures your brand connects with a wide range of potential customers, enhancing your market reach.",
    },
    {
      imgSrc:
        "/Assets/Images/Service/Services/Advantages_Video_Wala_Bus_Stand_Card_img/img_7.png",
      imgName: "Enhanced",
      imgName2: "Brand Recognition",
      imgNumber: "7",
      overlayDiscription:
        "With regular exposure to a massive audience, your brand gains visibility and builds recognition over time. The consistency of ads displayed across multiple locations ensures your business stays top-of-mind for your target audience.",
    },
    {
      imgSrc:
        "/Assets/Images/Service/Services/Advantages_Video_Wala_Bus_Stand_Card_img/img_8.png",
      imgName: "Hassle-Free ",
      imgName2: "Growth",
      imgNumber: "8",
      overlayDiscription:
        "Videowala Bus Stand’s streamlined advertising solutions eliminate the complexities of traditional campaigns. From creative development to execution, ReachOut Media ensures a seamless process, allowing you to focus on other aspects of your business while your brand grows effortlessly.",
    },
    {
      imgSrc: "/Assets/Images/Service/Services/Advantages_Video_Wala_Bus_Stand_Card_img/img_9.png",
      imgName: "Tailored",
      imgName2: "Campaigns",
      imgNumber: "9",
      overlayDiscription:
        "Understanding that every business is unique, ReachOut Media offers customized advertising solutions. Your campaigns can be tailored to meet specific business goals, ensuring maximum relevance and impact for your target audience.",
    },
  ];

  return (
    <>
      <section className="Advantages_Video_Wala_Bus_Stand">
        <div className="container">
          <div className="Heading-holder">
            <h1>Advantages of Videowala Bus Stand</h1>
          </div>

          <div className="Advantages_Video_Wala_Bus_Stand_holder">
            <div className="row">
              {advantagesData.map((advantage, index) => (
                <div
                  className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4"
                  key={index}
                >
                  <Advantages_Video_Wala_Bus_Stand_Card
                    imgSrc={advantage.imgSrc}
                    imgName={advantage.imgName}
                    imgName2={advantage.imgName2}
                    imgNumber={advantage.imgNumber}
                    overlayDiscription={advantage.overlayDiscription}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Advantages_Video_Wala_Bus_Stand;
